import { useState } from "react";
import { Wrapper, FieldWrapper, BtnAction, NoticeBar, LinkStyling } from "../../../styles/formStyles.js";

const ForgotPasswordStep = ({ initialEmail = "", onBack }) => {
	const [email, setEmail] = useState(initialEmail);
	const [error, setError] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (loading) return;
		setError("");
		setLoading(true);

		try {
			const response = await fetch(`${window.location.protocol}//${window.location.host}/wp-json/ahg/v1/password-setup/forgot-password`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": ahgLogin.nonce,
				},
				body: JSON.stringify({ email }),
			});

			const data = await response.json();

			if (data.code) {
				setError(data.message);
				return;
			}

			setMessage(data.message);
		} catch (err) {
			console.error("Error requesting password reset:", err);
			setError("Something went wrong. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	if (message) {
		return (
			<Wrapper>
				<p style={{ textAlign: "center", lineHeight: 1.6 }}>{message}</p>
				<p style={{ textAlign: "center", lineHeight: 1.6, fontSize: 14 }}>
					The link stays active until you use it. After resetting your password you'll set up multi-factor authentication again on your next
					sign in.
				</p>
				<LinkStyling
					href="#"
					onClick={(e) => {
						e.preventDefault();
						onBack();
					}}
				>
					Back to sign in
				</LinkStyling>
			</Wrapper>
		);
	}

	return (
		<Wrapper>
			<form onSubmit={handleSubmit}>
				{error && <NoticeBar role="alert">{error}</NoticeBar>}

				<p style={{ lineHeight: 1.6, fontSize: 14 }}>Enter your account email and we'll send you a link to reset your password.</p>

				<FieldWrapper>
					<label htmlFor="reset_email">Email Address</label>
					<input
						type="email"
						name="reset_email"
						id="reset_email"
						required
						value={email}
						onChange={(e) => {
							setEmail(e.target.value);
							setError("");
						}}
					/>
				</FieldWrapper>

				<p>
					<BtnAction type="submit" disabled={loading}>
						{loading ? "Sending..." : "Send link"}
					</BtnAction>
				</p>

				<LinkStyling
					href="#"
					onClick={(e) => {
						e.preventDefault();
						onBack();
					}}
				>
					Back to sign in
				</LinkStyling>
			</form>
		</Wrapper>
	);
};

export default ForgotPasswordStep;
